import * as React from 'react'
import { Card, CardContent, CardHeader, Box } from '@mui/material'
import { StandardStateSelect } from './StandardStateSelect'
import { StandardSubjectSelect } from './StandardSubjectSelect'
import { EdgateStandards } from './EdgateStandards'
import { KiddomStandards } from './KiddomStandards'
import { Changelist } from './Changelist'

export const UpdateStandards: React.FC = () => {
  const [selectedState, setSelectedState] = React.useState('')
  const [selectedSubject, setSelectedSubject] = React.useState('')

  // Invalidate subject when state changes
  React.useEffect(() => {
    setSelectedSubject('')
  }, [selectedState])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Card>
        <CardHeader
          title="Update Standards"
          slotProps={{ title: { variant: 'h6' } }}
          sx={{ pb: 0 }}
        />
        <CardContent sx={{ pt: 1 }}>
          <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column', py: 0 }}>
            <StandardStateSelect
              value={selectedState}
              onChange={setSelectedState}
            />
            <StandardSubjectSelect
              value={selectedSubject}
              onChange={setSelectedSubject}
            />
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardHeader
          title="EdGate Standards"
          slotProps={{ title: { variant: 'subtitle1' } }}
          sx={{ pb: 0 }}
        />
        <CardContent sx={{ pt: 1 }}>
          <EdgateStandards
            state={selectedState}
            kiddomSubject={selectedSubject}
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader
          title="Kiddom Standards"
          slotProps={{ title: { variant: 'subtitle1' } }}
          sx={{ pb: 0 }}
        />
        <CardContent sx={{ pt: 1 }}>
          <KiddomStandards state={selectedState} subject={selectedSubject} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader
          title="Changelist"
          slotProps={{ title: { variant: 'subtitle1' } }}
          sx={{ pb: 0 }}
        />
        <CardContent sx={{ pt: 1 }}>
          <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column', py: 0 }}>
            <Changelist state={selectedState} subject={selectedSubject} />
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}
